<template>
    <rkm-modal
        :loading="loading"
        :title="`Cadastro de baixa (${material.descricao})`"
        large
        ref="Modal"
    >
        <Form
            :material="material"
            @has-estoque="disableSave = !$event"
            @save="handleExit"
            ref="Form"
        />

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading || disableSave"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>

            <rkm-button
                :disabled="!!loading || disableSave"
                @click="$refs.Form.save(true)"
                color="primary"
            >
                Salvar e imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        material: {},
        disableSave: true,
    }),
    methods: {
        open(material) {

            this.material = material

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
    }
}
</script>